// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1F1OJ","title":"title-2hEHS"};